export default "__VITE_ASSET__By2sCgO9__"